<template>
  <v-container grid-list-md text-xs-left>
    
    <v-layout row wrap>
      <v-flex xs12 class="display-1 font-weight-light">
          TOOLS AND SERVICES
      </v-flex>

        <v-flex xs4 sm2>
            <v-img height="100" width="100" :src="require('@/assets/yammer_logo_new.png')"></v-img>
        </v-flex>

        <v-flex xs8 sm10>
          <h1>Yammer</h1>
          <p>Whether you’re a new manager or a seasoned pro, you’re always faced with new and unique challenges. Now you don’t have to take them on alone thanks to the FAA Managers Forum on Yammer, your source for resources to develop as a leader and navigate the trials of being a manager at FAA.</p>
        </v-flex>

      <v-flex xs12 sm6>
        <h4>What is Yammer?</h4>
        <ul>
          <li>Yammer is a social media site open to FAA employees</li>
          <li>Yammer connects you with your colleagues to share challenges, exchange ideas, provide coaching, and build and sustain your relationships across the Agency</li>
          <li>The FAA Managers Forum is a Yammer group restricted to FAA managers containing short learning resource posts, such as articles, blogs, podcasts, and videos centered around leadership development</li>
          <li>Access Yammer 24/7, anywhere, from any device (e.g., smart phone, laptop, or tablet)</li>
        </ul>
        <p></p>
        <h4>Get Started</h4>
        <ul>
          <li>Download the Yammer app from the app store to your smart phone or tablet, or visit <a href="https://www.yammer.com/faa.gov">https://www.yammer.com/faa.gov</a></li>
          <li>Create your account using your FAA email address</li>
          <li>Upload a photo (preferably with your face clearly visible)</li>
          <li>Complete the “About Me”, “Work”, and “Education” profile sections</li>
          <li>Add organization information to your profile (example: manager)</li>
          <li>Add additional information you would like to share with colleagues to your profile</li>
          <li>Request an invitation to the FAA Managers Forum</li>
        </ul>
      </v-flex>


      <v-flex xs12 sm6>
        <h4>Yammer Away</h4>
        <ul>
          <li>Check the group regularly, either using the mobile app or website</li>
          <li>Start new conversations by asking questions or posting challenges, ideas, and successes</li>
          <li>Jump into conversations others have started by offering your own take</li>
          <li>Respond to polls</li>
          <li>Comment on or “like” resources posted by the FLLI team</li>
        </ul>
      </v-flex>



    </v-layout>
   
  </v-container>
</template>

<script>

  export default {
    data () {
        return {
        image: require('@/assets/ThinkstockPhotos-516589445.jpg')
        }
    }
  }</script>

<style>

</style>
